import { suppliesCollectionIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * Sets the storefront display order of supplies collections to the given id
 * sequence (each collection's position becomes its index).
 */
export const reorderSuppliesCollections = unaryRpc({
  name: "reorderSuppliesCollections" as const,
  input: z.object({ orderedIds: z.array(suppliesCollectionIdFormat.schema) }),
  output: z.object({}),
});
